import React, { useState, useEffect } from 'react';
import Header from '../Landing/Header/Header'
import HeroSection from '../Landing/HeroSection/HeroSection'
import FeaturesSection from '../Landing/FeaturesSection/FeaturesSection'
import PricingSection from '../Landing/PricingSection/PricingSection'
import FAQSection from '../Landing/FAQSection/FAQSection'
import Footer from '../Landing/Footer/Footer'
import { useDocumentHead } from '../hooks/useDocumentHead'
import WhyTopSpeaks from '../Landing/WhyTopSpeaks/WhyTopSpeaks';
import VideoShowcase from '../Landing/VideoShowcase/VideoShowcase';
import StatisticsSection from '../Landing/StatisticsSection/StatisticsSection';
import SuccessStories from '../Landing/SuccessStories/SuccessStories';

const Landing = () => {
    useDocumentHead(
        'TopSpeaks | Elevate Your Speaking Skills with AI',
        'Start your journey to confident speaking with personalized feedback, instant slides, AI coaching, and progress tracking.',
        'index, follow'
    );
    const [activeSection, setActiveSection] = useState('home');

    useEffect(() => {
        const handleScroll = () => {
            const sections = document.querySelectorAll('section');
            sections.forEach(section => {
                const top = section.offsetTop - 100;
                const height = section.offsetHeight;
                if (window.scrollY >= top && window.scrollY < top + height) {
                    setActiveSection(section.id);
                }
            });
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div>
            <Header activeSection={activeSection} />
            <HeroSection />
            <StatisticsSection />
            <WhyTopSpeaks />
            <FeaturesSection />
            <SuccessStories />
            <VideoShowcase />
            <PricingSection />
            <FAQSection />
            <Footer />
        </div>
    );
};

export default Landing;